import { BaseService } from './BaseService';

export interface MaintenanceStatus {
    title: string | null;
    message: string | null;
    note: string | null | undefined;
}

export class MaintenanceService extends BaseService {
    public getMaintenanceStatus = async (accessToken: string): Promise<MaintenanceStatus> => {
        try {
            const response = await this.getResponseAsync<MaintenanceStatus>(
                {
                    commandPath: 'maintenanceStatus',
                },
                accessToken,
            );
                        // Validate the response
            // Validate the response
            // Validate the response
            if (typeof response !== 'object' || Array.isArray(response)) {
                throw new Error('Invalid JSON response received from the server.');
            }

            if (Object.keys(response).length === 0) {
                throw new Error('Empty response received from the server.');
            }

            return response;

        } catch (error) {
            // Log the error for debugging
            console.error('Error fetching maintenance status:', error);

            // Handle JSON parsing errors or unexpected responses
            if (error instanceof SyntaxError) {
                throw new Error('Failed to parse maintenance status response. Invalid JSON format.');
            }

            // Re-throw other errors
            throw error;
        }
    };
}